import { IconButton } from '@/components/atoms/IconButton';
import { Text } from '@/components/atoms/Text';

import iconDeleteSrc from '~/svg/IconCross.svg';
import { SvgIcon } from '@/components/SvgIcon';

type Props = {
  file: File;
  onRemove: (file: File) => void;
};

export const File = ({ file, onRemove }: Props) => {
  return (
    <div className='mt-6 flex w-fit items-center gap-x-2 rounded-3xl border border-gray-200 px-4 py-1'>
      <Text
        variant='body-m'
        classNames={{
          wrapper: 'text-brand-500',
        }}
      >
        {file.name}
      </Text>
      <IconButton
        type='button'
        classNames={{ root: 'p-0 h-4 w-4' }}
        variant='text'
        color='primary'
        slim
        size='s'
        onClick={() => onRemove(file)}
      >
        <SvgIcon src={iconDeleteSrc} />
      </IconButton>
    </div>
  );
};
